import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash'

import {
  Table,
  Jumbotron,
  Button,
  Tabs,
  Tab,
  Row,
  Grid,
  Col,
  Modal,
  Image,
  Panel,
  ButtonGroup,
  FormControl,
  FormGroup,
  ControlLabel,
  Alert,
  Label,
  Glyphicon
} from 'react-bootstrap';

import If from "../../utils/If"

import { categorysListUtils } from "../../utils/categorys-exercises"

import Loader from 'react-loader-advanced';

import '../../statics/css/table-publication.css'
import '../../statics/css/util.css'

import addPhoto from '../../statics/images/addphoto.svg'
import changePhoto from '../../statics/images/change_photo.svg'

//DAO
import { sendImagePublication } from '../../dao-firebase/daofirebase';

import TablePublications from '../feed/table-publications'
import { registerPublication, updatePublication } from '../../dao-firebase/publication-firebase';
import { sendNotificationFirebase } from '../../dao-firebase/notification-firebase';

import Cropper from 'react-easy-crop'
import getCroppedImg from '../../utils/cropImage'

class PublicationsList extends Component {

  constructor(props) {
    super(props);

    this.state = {

      gifToSave: undefined,

      form_title_publication: '',
      form_text_publication: '',
      form_filter_publication: '',

      //search
      search_table_trainings: '',

      //modal new publication
      showModalNewPublication: false,

      messageAll: '',
      messageNewExercise: '',

      crop: { x: 0, y: 0 },
      zoom: 1,
      aspect: 1 / 1,

      croppedImage: null,
      croppedAreaPixels: null,

      croppedToSave: null,

      //editting
      edittingPublication: false,
      publicationEditting: undefined,
    };

  }

  componentDidMount() {

  }

  componentWillMount() {

  }


  onInputChange(target) {

    console.log(target);

    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  uploadGifExercise() {

    let node = ReactDOM.findDOMNode(this.refs.inputGifExercise);
    if (node && node.focus instanceof Function) {
      node.click();
    }

  }

  handleGifUpload(event) {

    const file = event.target.files[0]

    if (file) {
      this.setState({
        gifToSave: file,
      })
    }

  }

  onChangeFilterPublication(event) {

    this.setState({
      form_filter_publication: event.target.value,
    })
  }

  openNewPublication() {
    this.setState({
      showModalNewPublication: true,
      form_title_publication: '',
      form_text_publication: '',
      form_filter_publication: 'all',
      gifToSave: undefined,
      edittingPublication: false,
      url_image: undefined,
    })
  }

  editPublication(pub) {
    this.setState({
      showModalNewPublication: true,
      form_title_publication: pub.data.title,
      form_text_publication: pub.data.text,
      form_filter_publication: pub.data.filter,
      gifToSave: undefined,
      url_image: pub.data.url_image,
      edittingPublication: true,
      publicationEditting: pub,
    })
  }

  handleCloseNewPublication() {
    this.setState({
      showModalNewPublication: false,
    })
  }

  renderMessage(message) {
    return (
      <p>
        <strong>{message.substring(0, message.indexOf(" "))}</strong>
        {message.substring(message.indexOf(" "))}
      </p>
    )
  }

  async squareImage(uidProfessor, uidPublication) {

    const { croppedAreaPixels } = this.state

    console.log("ENVIANDO CROPPED: ", croppedAreaPixels)
    let croppedImage = await getCroppedImg(
      URL.createObjectURL(this.state.gifToSave),
      croppedAreaPixels,
      0
    )

    console.log("CROPPED IMAGE: ", croppedImage);
    //this.savePublication();
    sendImagePublication(uidProfessor, croppedImage.file, uidPublication, (response, success) => {
      if (success) {
        //Atualizar a url da imagem da publicação
        //Em caso de sucesso a response é a url da imagem salva no storage
        updatePublication(uidProfessor, uidPublication, { url_image: response }, (response, success) => {

          if (success) {
            this.setState({
              messageAll: "Publicação criada com sucesso!",
              messageAllStatus: "success",

              form_title_publication: '',
              form_text_publication: '',
              form_filter_publication: '',

              showModalNewPublication: false,

              load: false,
            })

            setTimeout(() => {

              if (this.state.messageAll == "Publicação criada com sucesso!") {
                this.setState({
                  messageAll: '',
                });
              }
            }, 5000);

            //Trazendo scroll pra 0 pra garantir a visibilidade da mensagem
            window.scrollTo(0, 0);

          } else {
            this.setState({
              messageNewExercise: "Falha ao atualizar link da image no exercício: " + response.message,
              load: false,
              showModalNewPublication: false,
            })
          }
        })

      } else {
        this.setState({
          messageNewExercise: "Falha ao salvar a imagem: " + response.message,
          load: false,
          showModalNewPublication: false,
        })
      }
    })

  }

  savePublication() {

    //Nova publicação sendo registrada

    this.setState({
      load: true,
    })

    let uidProfessor = JSON.parse(localStorage.getItem("USER")).uid;

    //montando publicacao
    let publication = {
      title: this.state.form_title_publication,
      text: this.state.form_text_publication,
      status: "active",
      filter: this.state.form_filter_publication,
    }

    registerPublication(uidProfessor, publication, (response, success) => {
      if (success) {
        //Salvar imagem caso exista
        //Quando a resposta é sucesso ela vem em formato de doc
        let uidPublication = response.id;
        if (this.state.gifToSave) {
          this.squareImage(uidProfessor, uidPublication);
        } else {
          this.setState({

            messageAll: "Publicação criada com sucesso!",
            messageAllStatus: "success",

            form_title_publication: '',
            form_text_publication: '',
            form_filter_publication: '',

            showModalNewPublication: false,

            load: false,
          })

          setTimeout(() => {

            if (this.state.messageAll == "Publicação criada com sucesso!") {
              this.setState({
                messageAll: '',
              });
            }
          }, 5000);

          //Trazendo scroll pra 0 pra garantir a visibilidade da mensagem
          window.scrollTo(0, 0);
        }
      } else {
        this.setState({
          messageNewExercise: response.message,
          load: false,
          showModalNewPublication: false,
        });
      }
    })
  }

  onCropChange = crop => {
    this.setState({ crop })
  }

  onCropComplete = (croppedArea, croppedAreaPixels) => {
    //console.log("CROPPED AREA: ", croppedArea)
    //console.log("CROPPED AREA PIXELS: ", croppedAreaPixels)
    this.setState({
      croppedAreaPixels: croppedAreaPixels,
    })
  }

  onZoomChange = zoom => {
    this.setState({ zoom })
  }

  updatePublication(publication, updateAll) {

    if (updateAll) {

      this.setState({
        load: true,
      })

      publication.data.title = this.state.form_title_publication;
      publication.data.text = this.state.form_text_publication;
      publication.data.filter = this.state.form_filter_publication;
    }

    let uidProfessor = JSON.parse(localStorage.getItem("USER")).uid;
    updatePublication(uidProfessor, publication.id, publication.data, (response, success) => {

      if (success) {

        if (this.state.gifToSave) {
          this.squareImage(uidProfessor, publication.id);
        } else {

          this.setState({

            messageAll: "Publicação inativada com sucesso!",
            messageAllStatus: "success",

            load: false,
          })

          setTimeout(() => {

            if (this.state.messageAll == "Publicação inativada com sucesso!") {
              this.setState({
                messageAll: '',
              });
            }
          }, 5000);
        }




      } else {

        this.setState({

          messageAll: "Erro ao inativar publicação: " + response.message,
          messageAllStatus: "warning",

          load: false,
        })

        setTimeout(() => {

          if (this.state.messageAll == "Erro ao inativar publicação: " + response.message) {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);

      }

    })
  }

  render() {

    const { edittingPublication, publicationEditting } = this.state

    return (
      <div className="publication-page">

        {this.state.messageAll != '' ?
          <Alert bsStyle={!this.state.messageAllStatus || this.state.messageAllStatus == '' ? 'warning' : this.state.messageAllStatus}>
            {this.renderMessage(this.state.messageAll)}
          </Alert>
          : null}

        <Grid>
          <Row className="infos-body-profile">
            <Col md={12} className="no-p-left no-p-right">
              <Jumbotron>
                <h2>Nova publicação</h2>
                <p>Compartilhe textos e fotos com seus alunos</p>
                <p>
                  <Button bsStyle="warning" onClick={() => this.openNewPublication()}>Criar publicação</Button>
                </p>
              </Jumbotron>
            </Col>
          </Row>
        </Grid>

        <Grid>
          <Row className="flex-row">
            <Col xs={9} md={9} className="no-p-left no-p-right text-left">
              <h2 className="label-table">Publicações</h2>
            </Col>

          </Row>
        </Grid>

        <TablePublications updatePublication={(publi) => this.updatePublication(publi, false)} editPublication={(publi) => this.editPublication(publi)} />

        {/* <Button bsStyle="warning" onClick={() => sendNotificationFirebase()}>Enviar notificação</Button> */}

        <Modal show={this.state.showModalNewPublication}
          dialogClassName="custom-modal-new-publi">
          <Loader show={this.state.load} message={<div className="loader"></div>}
            backgroundStyle={{ backgroundColor: 'none' }}
            foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>
            <Modal.Header>
              <Modal.Title>Criar publicação</Modal.Title>
            </Modal.Header>

            <Modal.Body className="modal-body-new-exercise">

              {this.state.messageNewExercise != '' ?
                <Alert bsStyle={!this.state.messageNewExerciseStatus || this.state.messageNewExerciseStatus == '' ? 'warning' : this.state.messageNewExerciseStatus}>
                  <p>{this.state.messageNewExercise}</p>
                </Alert>
                : null}

              {/* <Grid>
                <Row className="flex-row">
                  <Col xs={4} md={4} className="img-publi no-p-left no-p-right"> */}
              {/* <div className="center-cropped2"> */}
              <div className="layoutPubli">
                <div className="img-publi background-video-new-exercise" onClick={() => {
                  if (!this.state.gifToSave) {
                    this.uploadGifExercise()
                  }
                }}>
                  <If test={this.state.gifToSave}>

                    {/* <div className="center-cropped3">
                          <Image src={this.state.gifToSave ? URL.createObjectURL(this.state.gifToSave) : ""} />
                        </div> */}
                    <Cropper
                      image={this.state.gifToSave ? URL.createObjectURL(this.state.gifToSave) : ""}
                      crop={this.state.crop}
                      zoom={this.state.zoom}
                      aspect={this.state.aspect}
                      onCropChange={this.onCropChange}
                      onCropComplete={this.onCropComplete}
                      onZoomChange={this.onZoomChange}
                      cropSize={{
                        width: 300,
                        height: 300
                      }}
                    />
                    {/* <div className="overlay-img" />

                        <p className="label-action-new-video-edit">Editar</p> */}
                  </If>
                  <If test={this.state.url_image && !this.state.gifToSave}>
                    <Cropper
                      image={this.state.url_image}
                      crop={this.state.crop}
                      zoom={this.state.zoom}
                      aspect={this.state.aspect}
                      onCropChange={this.onCropChange}
                      onCropComplete={this.onCropComplete}
                      onZoomChange={this.onZoomChange}
                      cropSize={{
                        width: 300,
                        height: 300
                      }}
                    />
                  </If>

                  <If test={!this.state.gifToSave && this.state.form_url_gif_exercise}>

                    <div className="center-cropped3">
                      <Image src={this.state.form_url_gif_exercise ? this.state.form_url_gif_exercise : ""} />
                    </div>
                    <div className="overlay-img" />

                    <p className="label-action-new-video-edit">Editar</p>
                  </If>
                  <If test={!this.state.gifToSave && !this.state.form_url_gif_exercise}>

                    <Image src={addPhoto} responsive className="img-new-video" />

                    <p className="label-action-new-video">Adicionar</p>
                  </If>
                  <FormControl
                    ref="inputGifExercise"
                    className="input-file-body input-file-gone"
                    type="file"
                    onChange={(e) => this.handleGifUpload(e)}
                  />

                  {
                    this.state.gifToSave ?

                      <Button bsSize="small" className="button-change-photo" onClick={() => this.uploadGifExercise()}>
                        <Glyphicon className="black" glyph="picture" />
                        {/* <Image src={changePhoto} responsive className="change-photo" /> */}
                      </Button>
                      : null
                  }

                </div>

              </div>
              <div className="form-publi-infos">
                <FormGroup>
                  <ControlLabel>Quem pode ver?</ControlLabel>
                  <FormControl componentClass="select" placeholder="Selecione" onChange={(event) => this.onChangeFilterPublication(event)}>
                    <option value="all" selected={this.state.form_filter_publication == "all" ? true : false}>Todos</option>
                    <option value="consult" selected={this.state.form_filter_publication == "consult" ? true : false}>Consultoria esportiva</option>
                    <option value="personal" selected={this.state.form_filter_publication == "personal" ? true : false}>Personal trainer</option>
                  </FormControl>
                </FormGroup>

                <FormGroup controlId="formControlsNameExercise">
                  <ControlLabel>Título</ControlLabel>
                  <FormControl
                    name="form_title_publication"
                    type="text"
                    value={this.state.form_title_publication}
                    placeholder="Insira o nome"
                    onChange={(event) => this.onInputChange(event.target)} />
                </FormGroup>

                <FormGroup controlId="formControlsDescriptionExercise">
                  <ControlLabel>Texto da publicação</ControlLabel>
                  <FormControl
                    rows="5"
                    componentClass="textarea"
                    name="form_text_publication"
                    type="text"
                    className="textarea-fixed"
                    value={this.state.form_text_publication}
                    placeholder="Insira o texto"
                    onChange={(event) => this.onInputChange(event.target)} />
                </FormGroup>
              </div>

              {/* </Col>
                </Row>
              </Grid> */}
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={() => this.handleCloseNewPublication()}>Fechar</Button>
              {
                edittingPublication ?
                  <Button bsStyle="success" onClick={() => this.updatePublication(publicationEditting, true)}>Atualizar</Button>
                  :
                  <Button bsStyle="primary" onClick={() => this.savePublication(false)}>Publicar</Button>
              }
              {/* <Button bsStyle="primary" onClick={() => this.showCroppedImage()}>Gerar foto</Button> */}
            </Modal.Footer>

          </Loader>
        </Modal>

      </div>
    );
  }
}

export default PublicationsList;



// WEBPACK FOOTER //
// src/components/feed/publications-list.js